export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";